<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    transition="dialog-bottom-transition"
    content-class="dialog-rose-lega"
  >
    <v-card class="dialog-rose-lega-card navy darken-2">
      <v-card-title class="secondary white--text dialog-rose-lega-title">
        <span class="font-hemi-head">ROSE LEGA</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dismiss">
          <v-icon class="white--text">close</v-icon>
        </v-btn>
      </v-card-title>

      <rose-lega
        class="dialog-rose-lega-content"
        show-filters
        disable-squadra-menu
      ></rose-lega>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import RoseLega from "../RoseLega";

export default {
  name: "dialog-rose-lega",
  components: {
    RoseLega,
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    console.log("--> DialogRoseLega ready.");
    db.on("showDialogRoseLega", this.show);
  },
  destroyed() {
    console.log("<-- DialogRoseLega destroyed.");
    db.off("showDialogRoseLega", this.show);
  },
  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-rose-lega-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.dialog-rose-lega-title {
  flex: 0 0 auto;
}

.dialog-rose-lega-content {
  flex: 1;
  min-height: 0;
}
</style>
